import { ID_COMMUNICATION } from 'civil-status/components/step/form/last-step/accordions/section/list/list-communication';
import { CodeSubject } from 'civil-status/constants/code-subject-section';
import {
  ParentVM,
  ScioglimentoUnioneCivileAtti,
  SectionVM,
} from 'civil-status/view-models/step-form';

export const transformerScioglimentoUnioneCivileAtti = (
  idEvento?: number,
  dataSection?: SectionVM,
  dataDatiSeparazioniUC?: SectionVM,
  subjectUniCivScio?: Array<ParentVM>,
  subjectAvvUniCivScio?: Array<ParentVM>
): ScioglimentoUnioneCivileAtti | undefined => {
  if (
    !(
      dataSection ||
      dataDatiSeparazioniUC ||
      (subjectUniCivScio || []).length > 0 ||
      (subjectAvvUniCivScio || []).length > 0
    )
  ) {
    return undefined;
  }

  const subjectUniciv1Scio = subjectUniCivScio?.find(
    (item) => item.codeSubject === CodeSubject.UNICIV1_SCIO
  );
  const subjectUniciv2Scio = subjectUniCivScio?.find(
    (item) => item.codeSubject === CodeSubject.UNICIV2_SCIO
  );

  const subjectAvvUniciv1Scio = subjectAvvUniCivScio?.find(
    (item) => item.codeSubject === CodeSubject.AVVOCUC1
  );
  const subjectAvvUniciv2Scio = subjectAvvUniCivScio?.find(
    (item) => item.codeSubject === CodeSubject.AVVOCUC2
  );

  return {
    key: {
      idEvento,
    },
    flagAssegnoMantenimento: dataDatiSeparazioniUC
      ? dataDatiSeparazioniUC?.isMaintenanceAllowance
        ? '1'
        : '0'
      : undefined,
    descrizioneDatiAssegnoMantenim: dataDatiSeparazioniUC?.maintenanceAllowance || undefined,
    flagInGiudizioPendente: dataDatiSeparazioniUC
      ? dataDatiSeparazioniUC?.isPendingJudgment
        ? '1'
        : '0'
      : undefined,
    descrizioneAutoritaGiudiziaria: dataDatiSeparazioniUC?.judicialAuthority || undefined,
    flagPresenzaConiuge1: dataDatiSeparazioniUC
      ? dataDatiSeparazioniUC?.isHusband
        ? '1'
        : '0'
      : undefined,
    flagPresenzaAvvConiuge1: dataDatiSeparazioniUC
      ? dataDatiSeparazioniUC?.isLawyerHusband
        ? '1'
        : '0'
      : undefined,
    flagPresenzaConiuge2: dataDatiSeparazioniUC
      ? dataDatiSeparazioniUC?.isWife
        ? '1'
        : '0'
      : undefined,
    flagPresenzaAvvConiuge2: dataDatiSeparazioniUC
      ? dataDatiSeparazioniUC?.isLawyerWife
        ? '1'
        : '0'
      : undefined,
    dataUnioneCivile: dataDatiSeparazioniUC?.dateMarriage
      ? dataDatiSeparazioniUC?.dateMarriage?.toFormat('yyyy-MM-dd')
      : undefined,
    dataConfermaAccordo: dataDatiSeparazioniUC?.dateAgreementConfirmation
      ? dataDatiSeparazioniUC?.dateAgreementConfirmation?.toFormat('yyyy-MM-dd')
      : undefined,
    descrizioneOfficianteUnioneCivile: dataDatiSeparazioniUC?.celebratedBy || undefined,
    dataComunicazione: dataSection?.dataSend
      ? dataSection?.dataSend?.toFormat('yyyy-MM-dd')
      : undefined,
    flagConRaccomandataAr: dataSection?.typeCommunication
      ? dataSection?.typeCommunication?.id === ID_COMMUNICATION.ID_RACCOMANDATA
        ? '1'
        : '0'
      : undefined,
    descrizioneAltroMezzoComunicaz: dataSection?.otherTypeCommunicationDescription || undefined,
    tipoIndirizzoComunicazione: dataSection?.address || undefined,
    dataRicezione: dataSection?.dataReception
      ? dataSection?.dataReception?.toFormat('yyyy-MM-dd')
      : undefined,
    tipoComprensioneConiuge1:
      subjectUniciv1Scio?.generality?.conditionsItem?.id?.toString() || undefined,
    descrizioneImpedimScrittConiuge1: subjectUniciv1Scio?.generality?.reasonImpediment || undefined,
    tipoComprensioneConiuge2:
      subjectUniciv2Scio?.generality?.conditionsItem?.id?.toString() || undefined,
    descrizioneImpedimScrittConiuge2: subjectUniciv2Scio?.generality?.reasonImpediment || undefined,
    nomeForoAvvConiuge1: subjectAvvUniciv1Scio?.generality?.lawyerForum || undefined,
    nomeForoAvvConiuge2: subjectAvvUniciv2Scio?.generality?.lawyerForum || undefined,
  };
};
